/* eslint-disable no-undef */
import firebase from 'firebase';
import 'firebase/firestore';

const config = {
	apiKey: 'AIzaSyCuxlKsqkNHin6SaNNDyUVIuae_yaghwUg',
	authDomain: 'translations-database.firebaseapp.com',
	databaseURL: 'https://translations-database.firebaseio.com',
	projectId: 'translations-database',
	storageBucket: 'translations-database.appspot.com',
	messagingSenderId: '316723552444',
	appId: '1:316723552444:web:07ba7247eea70b5210b0b9',
};

const configDev = {
	apiKey: 'AIzaSyCuxlKsqkNHin6SaNNDyUVIuae_yaghwUg',
	authDomain: 'translations-database.firebaseapp.com',
	databaseURL: 'https://translations-database.firebaseio.com',
	projectId: 'translations-database',
	storageBucket: 'translations-database.appspot.com',
	messagingSenderId: '316723552444',
	appId: '1:316723552444:web:07ba7247eea70b5210b0b9',
};

// test config !!!!!!!!!!!!!
// const configDev = {
//     apiKey: 'AIzaSyDgH01wWGBT8OiUh_2DU1BiYPMfF1uPYrA',
//     authDomain: 'translation-db.firebaseapp.com',
//     databaseURL: 'https://translation-db.firebaseio.com',
//     projectId: 'translation-db',
//     storageBucket: 'translation-db.appspot.com',
//     messagingSenderId: '405503493819',
//     appId: '1:405503493819:web:b4b480de29f8d0b48ecb9e',
//     measurementId: 'G-H8JYP6CTNM',
// }


// Live environment
if (process.env.NODE_ENV === 'production') {
	firebase.initializeApp(config);
}

// Staging environment
if (process.env.NODE_ENV === 'staging') {
	firebase.initializeApp(config);
}

// Local environment
if (
	process.env.NODE_ENV !== 'production' &&
	process.env.NODE_ENV !== 'staging'
) {
	firebase.initializeApp(configDev);
}

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

// timestampsInSnapshots: is now default and was generating an warn
const settings = {
};

db.settings(settings);

// firebase collections
const groupsCollection = db.collection('groups');
const labelsCollection = db.collection('labels');
const languagesCollection = db.collection('languages');
const translationsCollection = db.collection('translations');
const setsCollection = db.collection('sets');
const backupsCollection = db.collection('backups');

export {
	db,
	auth,
	currentUser,
	groupsCollection,
	labelsCollection,
	languagesCollection,
	translationsCollection,
	setsCollection,
	backupsCollection,
};



// WEBPACK FOOTER //
// ./src/services/firebaseConfig.js